import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";

export const Footer = () => (
  <footer className="border-t border-sage-200 mt-16 pb-24 lg:pb-0">
    <div className="wrap py-10 flex flex-col sm:flex-row sm:items-center justify-between gap-6">
      <div className="flex items-center gap-6">
        <Logo small />
        <div className="border-l border-ink/20 pl-6 text-sm text-ink/80" data-testid="footer-tagline">
          uplinkcoffee.com <span className="mx-1.5 text-ink/30">|</span> PT. Uplink Coffee Network
        </div>
      </div>
      <Link to="/staf/login" className="text-xs text-muted2 hover:text-forest underline-offset-4 hover:underline" data-testid="footer-staff-link">Masuk Staf</Link>
    </div>
  </footer>
);
